import { FaSpinner } from 'react-icons/fa';

export const FriendsMenuLazyFallback = () => (
	<div className="bg-darker h-100 w-100 d-flex border-left border-dark text-dark p-4">
		<FaSpinner className="icon-spin" />
	</div>
);
